module.exports = __webpack_public_path__ + "static/media/code3.d4b42ddd.jpg";